import { deserializeNumberParam,
  serializeNumberParam } from '../../utils/params-formatting';
import { useStateParams } from '../use-state-params';

export function usePageParam() {
  return useStateParams<number>(0, 'page', serializeNumberParam, deserializeNumberParam);
}